import React from "react";
import { connect } from "react-redux";

import { history } from "state/history";

import { getStudentIDList } from "state/school_money/selectors";

import EntitySelector from "components/EntitySelector";
import StudentName from "components/school_money/StudentName";

import "./StudentSelector.css";

class StudentSelector extends React.Component {
  
  changeStudent = studentID => {
    history.push(this.props.generatePath(studentID));
  }
  
  render() {
    const { studentIDList, selectedStudentID } = this.props;
    return (
      <EntitySelector
        cssBlockName="student-selector"
        entityIDList={studentIDList}
        selectedEntityID={selectedStudentID}
        loop={false}
        onSelectEntity={this.changeStudent}
      >
        { studentID => <StudentName studentID={studentID} /> }
      </EntitySelector>
    )
  }
  
}

export default connect(
  state => ({
    studentIDList: getStudentIDList(state)
  })
)(StudentSelector);



// WEBPACK FOOTER //
// ./src/components/school_money/StudentSelector.js